<template>
  <div>
    <a-row type="flex" align="middle" style="margin-bottom: 16px">
      <a-col :span="6" :md="6"> </a-col>
      <a-col
        :span="18"
        :md="18"
        style="display: flex; align-items: center; justify-content: flex-end"
      >
        <el-date-picker
          v-model="Query.startYmd"
          type="date"
          format="yyyy 年 MM 月 dd 日"
          value-format="yyyyMMdd"
          size="small"
          placeholder="选择日期"
        >
        </el-date-picker>
        <label style="margin: 0 10px">至</label>
        <el-date-picker
          v-model="Query.endYmd"
          type="date"
          format="yyyy 年 MM 月 dd 日"
          value-format="yyyyMMdd"
          size="small"
          placeholder="选择日期"
          style="margin-right: 10px"
        >
        </el-date-picker>
        <a-input
          v-model="Query.skey"
          placeholder="关键字"
          size="small"
          style="width: 150px; margin-right: 10px"
        />
        <a-button type="primary" icon="search" size="small" @click="GetNews()">
          查询
        </a-button>
      </a-col>
    </a-row>

    <a-row :gutter="[24, 16]" justify="space-between">
      <a-col :span="12" :xxl="12" :xl="12" :lg="24" :md="24" :sm="24" :xs="24">
        <wei-bo ref="WeiBo"></wei-bo>
      </a-col>
      <a-col :span="12" :xxl="12" :xl="12" :lg="24" :md="24" :sm="24" :xs="24">
        <dou-yin ref="DouYin"></dou-yin>
      </a-col> 
    </a-row>
    <a-row :gutter="[24, 16]" justify="space-between">
      <a-col :span="12" :xxl="12" :xl="12" :lg="24" :md="24" :sm="24" :xs="24">
        <tou-tiao ref="TouTiao"></tou-tiao>
      </a-col>
      <a-col :span="12" :xxl="12" :xl="12" :lg="24" :md="24" :sm="24" :xs="24">
        <bai-du ref="Baidu"></bai-du>
      </a-col> 
    </a-row>
    <a-row :gutter="[24, 16]" justify="space-between">
      <a-col :span="12" :xxl="12" :xl="12" :lg="24" :md="24" :sm="24" :xs="24">
        <teng-xun ref="TengXun"></teng-xun>
      </a-col>
      <a-col :span="12" :xxl="12" :xl="12" :lg="24" :md="24" :sm="24" :xs="24">
        
      </a-col> 
    </a-row>
  </div>
</template>

<script>
import { WeiBo,DouYin,TouTiao,BaiDu, TengXun } from "./components/index.js";
export default {
  components: {
    WeiBo,DouYin,TouTiao,BaiDu,TengXun
  },
  data() {
    return {
      Query: {
        skey: "",
        startYmd: "",
        endYmd: "",
        pageIndex: 1,
        pageSize: 20,
      },
    };
  },
  created() {
    // 获取当前日期并格式化为 yyyyMMdd 格式
    const getCurrentDate = () => {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}${month}${day}`;
    };

    const currentDate = getCurrentDate();
    this.Query.startYmd = currentDate;
    this.Query.endYmd = currentDate;
    this.GetNews();
  },
  methods: {
    GetNews() {
      this.$nextTick(() => {
        this.$refs.WeiBo.GetWeiBoInfos(this.Query);
        this.$refs.DouYin.GetDouYinInfos(this.Query);
        this.$refs.TouTiao.GetTouTiaoInfos(this.Query);
        this.$refs.Baidu.GetBaiDuInfos(this.Query);
        this.$refs.TengXun.GetTengXunInfos(this.Query);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 180px;
}
</style>